import { baseClientValidation } from "form-validations/base-client-validation";

export const validate = values => {
  return baseClientValidation(values)
};
